import * as React from "react";
import List from "@mui/material/List";
import Tooltip from "@mui/material/Tooltip";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

const TooltipMsg = `This Dispatch schedule is inactive. Please activate this schedule to select this value and proceed.`;
const NoOptionsMsg = `Dispatch schedule not available for the selected combination. Please get the dispatch schedule created for the selected combination of Academic Group, Term and Course ID.`;

const SelectDispatchMenu = ({
  options = [],
  isFieldDisabled = false,
  handleChange,
  selectedValue,
}) => {
  options.sort((a, b) => a.status.localeCompare(b.status)); //  ACTIVE dispatch follwed by INACTIVE

  const [selectedIndex, setSelectedIndex] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  React.useEffect(() => {
    const foundVal = options.findIndex(
      (item) => item.value === selectedValue.value
    );
    if (foundVal !== -1) setSelectedIndex(foundVal);
    else setSelectedIndex("");
  }, [selectedValue]);

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    // setSelectedIndex(index);
    setAnchorEl(null);

    handleChange(options[index]);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <List
        component="div"
        aria-label="Dispatch schedular"
        sx={{ bgcolor: "background.paper" }}
        style={{
          height: "42px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          // ...(isFieldDisabled && {
          //   padding: "0",
          //   backgroundColor: "#ededed",
          //   color: "#0f0f0f",
          // }),
        }}
      >
        <ListItemButton
          disabled={isFieldDisabled}
          id="lock-button"
          aria-haspopup="listbox"
          aria-controls="lock-menu"
          aria-label="dispatch selelction from 1-25"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickListItem}
          style={{ padding: "0 8px", height: "100%" }}
        >
          <ListItemText
            secondaryTypographyProps={{ fontSize: "12px" }}
            secondary={
              selectedIndex !== ""
                ? options[selectedIndex]?.label
                : "Dispatch schedular"
            }
          />
        </ListItemButton>
      </List>
      <Menu
        id="lock-menu"
        // placement="bottom-end"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
        sx={{
          "& .MuiPaper-root.MuiPopover-paper.MuiMenu-paper": {
            maxWidth: "300px",
            marginTop: "1rem",
          },
        }}
      >
        {options.length ? (
          options.map((option, index) => {
            const isInactive = option.status.toLowerCase() === "inactive";
            return (
              <MenuItem
                key={index}
                // disabled={isInactive} // tooltip won't work
                selected={index === selectedIndex}
                onClick={(event) =>
                  !isInactive && handleMenuItemClick(event, index)
                }
                style={{
                  cursor: isInactive ? "not-allowed" : "pointer",
                  color: isInactive ? "#ccc" : "black",
                }}
                // className="px-2 text-sm"
              >
                {isInactive ? (
                  <Tooltip title={TooltipMsg}>{option.label}</Tooltip>
                ) : (
                  option.label
                )}
              </MenuItem>
            );
          })
        ) : (
          <div className="px-2 text-xs">{NoOptionsMsg}</div>
        )}
      </Menu>
    </div>
  );
};

export default SelectDispatchMenu;
